import { render, staticRenderFns } from "./AboutExistingSpousalSupportOrder.vue?vue&type=template&id=2b86f307"
import script from "./AboutExistingSpousalSupportOrder.vue?vue&type=script&lang=ts"
export * from "./AboutExistingSpousalSupportOrder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports